import { rescheduleBooking as mutation } from "../../lib/graphql";
import { setLoaderStart, setLoaderComplete } from "../loader/loader";
import showToaster from "../../helpers/toastrMessgaes/showToaster";
import { closeHeaderModal } from "../siteadmin/modalActions";

// Reschedule an accepted job from the web tracking page (parity with the app). scheduleFrom = Unix sec.
export function rescheduleBookingAction({ bookingId, scheduleFrom }) {
    return async (dispatch, getState, { client }) => {
        try {
            if (typeof navigator !== 'undefined' && !navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' });
                return false;
            }
            dispatch(setLoaderStart('rescheduleBooking'));

            const { data } = await client.mutate({
                mutation,
                variables: { bookingId: Number(bookingId), scheduleFrom: Number(scheduleFrom) },
                fetchPolicy: 'no-cache',
            });

            dispatch(setLoaderComplete('rescheduleBooking'));

            if (data?.rescheduleBooking?.status === 200) {
                dispatch(closeHeaderModal('rescheduleForm'));
                await showToaster({ messageId: 'rescheduleSuccess', toasterType: 'success' });
                return true;
            }
            await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: { content: data?.rescheduleBooking?.errorMessage } });
            return false;
        } catch (error) {
            dispatch(setLoaderComplete('rescheduleBooking'));
            await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: { content: error?.message } });
            return false;
        }
    };
}
